import React, { useState, useEffect } from "react";

function getVisitorCount() {
  let count = parseInt(localStorage.getItem("vbkp_visitor_count") || "0");
  count += 1;
  localStorage.setItem("vbkp_visitor_count", count);
  return count;
}

export default function Footer() {
  // CLOCK
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // VISITOR COUNTER
  const [visitorCount, setVisitorCount] = useState(0);
  useEffect(() => {
    setVisitorCount(getVisitorCount());
  }, []);

  // Format date/time
  const dateStr = now.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const timeStr = now.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return (
    <footer style={{
      background: "#222",
      color: "#888",
      padding: "28px 0",
      fontSize: "1.1em",
      marginTop: 24
    }}>
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-md-6 col-12 mb-3 mb-md-0">
            <div className="footer-clock-date">
              <div className="footer-date">{dateStr}</div>
              <div className="footer-time" style={{ fontWeight: 600 }}>{timeStr}</div>
            </div>
            <div className="footer-visitor-counter mt-2">
              <i className="fa fa-user" style={{ marginRight: 4 }}></i>
              Visitor Count: {visitorCount}
            </div>
          </div>
          <div className="col-md-6 col-12 text-md-end text-center">
            <p style={{ margin: "10px 0" }}>
              Copyright &copy; 2025 VBKP
            </p>
            <ul className="social-icon" style={{
              listStyle: "none",
              padding: 0,
              display: "inline-flex",
              gap: 12
            }}>
              <li>
                <a href="https://www.facebook.com/share/1AfB4RYwpN/"
                  className="fa fa-facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#888", fontSize: 20 }}></a>
              </li>
              <li>
                <a href="https://www.youtube.com/@vidyabhartikhel7717"
                  className="fa fa-youtube"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#888", fontSize: 20 }}></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 767.98px) {
          .footer-date, .footer-time, .footer-visitor-counter {
            text-align: center !important;
          }
          .footer-clock-date {
            text-align: center !important;
          }
          .text-md-end {
            text-align: center !important;
          }
        }
      `}</style>
    </footer>
  );
}
